import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { PageTitle, Card, inputCls } from "@/components/admin/ui";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const load = () => api.get("/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/categories", { name: name.trim() }); setName(""); load(); toast.success("Category added"); }
    catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
  };
  const del = async (id) => { if (!window.confirm("Delete category?")) return; await api.delete(`/categories/${id}`); load(); };

  return (
    <div data-testid="admin-categories">
      <PageTitle title="Categories" subtitle="Blog categories for organizing articles" />
      <Card className="max-w-2xl">
        <div className="flex gap-2 mb-6">
          <input className={inputCls} placeholder="New category name" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid="category-name-input" />
          <button onClick={add} className="bg-navy text-ivory px-5 rounded-sm inline-flex items-center gap-2 shrink-0" data-testid="add-category"><Plus size={16} /> Add</button>
        </div>
        <div className="space-y-2">
          {cats.map((c) => (
            <div key={c.id} className="flex items-center justify-between py-2.5 px-3 border border-slate-100 rounded-sm" data-testid={`category-${c.slug}`}>
              <span className="text-navy text-sm">{c.name}</span>
              <button onClick={() => del(c.id)} className="text-slate-400 hover:text-red-500 p-1"><Trash2 size={15} /></button>
            </div>
          ))}
          {cats.length === 0 && <p className="text-slate-400 text-sm">No categories yet.</p>}
        </div>
      </Card>
    </div>
  );
}
